import Name from "./components/Name.vue"
import AddressCityStateZipCode from "./components/AddressCityStateZipCode.vue"
import DateOfBirth from "./components/DateOfBirth.vue"
import Email from "./components/Email.vue"

import VehicleConfirmation from "./components/VehicleConfirmation.vue"
import VehicleYear from "./components/VehicleYear.vue"
import VehicleMake from "./components/VehicleMake.vue"
import VehicleModel from "./components/VehicleModel.vue"
import VehicleTrim from "./components/VehicleTrim.vue"
import VehicleVin from "./components/VehicleVin.vue"
import VehiclePrimaryUseType from "./components/VehiclePrimaryUseType.vue"
import VehicleOwnershipType from "./components/VehicleOwnershipType.vue"
import VehicleAnnualMileage from "./components/VehicleAnnualMileage.vue"
import VehicleDaysDrivenPerWeek from "./components/VehicleDaysDrivenPerWeek.vue"
import AddAnotherVehicle from "./components/AddAnotherVehicle.vue"

import IsInsured from "./components/IsInsured.vue"
import CurrentInsurer from "./components/CurrentInsurer.vue"
import InsuranceLength from "./components/InsuranceLength.vue"
import RequestedCoverageType from "./components/RequestedCoverageType.vue"
import NumberOfDrivers from "./components/NumberOfDrivers.vue"
import LicenseStatus from "./components/LicenseStatus.vue"
import AccidentsOrTicketsInPast3Years from "./components/AccidentsOrTicketsInPast3Years.vue"
import Dui from "./components/Dui.vue"
import NeedsSr22 from "./components/NeedsSr22.vue"
import CreditRating from "./components/CreditRating.vue"
import IsMarried from "./components/IsMarried.vue"
import CurrentResidenceType from "./components/CurrentResidenceType.vue"
import IsInterestedInHomeOrRentersInsuranceQuotes from "./components/IsInterestedInHomeOrRentersInsuranceQuotes.vue"
import CurrentResidenceLength from "./components/CurrentResidenceLength.vue"
import Gender from "./components/Gender.vue"
import PhoneNumber from "./components/PhoneNumber.vue"

const steps = [
    Name.name,
    AddressCityStateZipCode.name,
    DateOfBirth.name,
    Email.name,

    VehicleConfirmation.name,
    VehicleYear.name,
    VehicleMake.name,
    VehicleModel.name,
    VehicleTrim.name,
    VehicleVin.name,
    VehiclePrimaryUseType.name,
    VehicleOwnershipType.name,
    VehicleAnnualMileage.name,
    VehicleDaysDrivenPerWeek.name,
    AddAnotherVehicle.name,

    IsInsured.name,
    CurrentInsurer.name,
    InsuranceLength.name,
    RequestedCoverageType.name,
    NumberOfDrivers.name,
    LicenseStatus.name,
    AccidentsOrTicketsInPast3Years.name,
    Dui.name,
    NeedsSr22.name,
    CreditRating.name,
    IsMarried.name,
    CurrentResidenceType.name,
    IsInterestedInHomeOrRentersInsuranceQuotes.name,
    CurrentResidenceLength.name,
    Gender.name,
    PhoneNumber.name
];

const stepValues = {
    Name: Name.name,
    AddressCityStateZipCode: AddressCityStateZipCode.name,
    DateOfBirth: DateOfBirth.name,
    Email: Email.name,

    VehicleConfirmation: VehicleConfirmation.name,
    VehicleYear: VehicleYear.name,
    VehicleMake: VehicleMake.name,
    VehicleModel: VehicleModel.name,
    VehicleTrim: VehicleTrim.name,
    VehicleVin: VehicleVin.name,
    VehiclePrimaryUseType: VehiclePrimaryUseType.name,
    VehicleOwnershipType: VehicleOwnershipType.name,
    VehicleAnnualMileage: VehicleAnnualMileage.name,
    VehicleDaysDrivenPerWeek: VehicleDaysDrivenPerWeek.name,
    AddAnotherVehicle: AddAnotherVehicle.name,

    IsInsured: IsInsured.name,
    CurrentInsurer: CurrentInsurer.name,
    InsuranceLength: InsuranceLength.name,
    RequestedCoverageType: RequestedCoverageType.name,
    NumberOfDrivers: NumberOfDrivers.name,
    LicenseStatus: LicenseStatus.name,
    AccidentsOrTicketsInPast3Years: AccidentsOrTicketsInPast3Years.name,
    Dui: Dui.name,
    NeedsSr22: NeedsSr22.name,
    CreditRating: CreditRating.name,
    IsMarried: IsMarried.name,
    CurrentResidenceType: CurrentResidenceType.name,
    IsInterestedInHomeOrRentersInsuranceQuotes: IsInterestedInHomeOrRentersInsuranceQuotes.name,
    CurrentResidenceLength: CurrentResidenceLength.name,
    Gender: Gender.name,
    PhoneNumber: PhoneNumber.name
};

export { steps, stepValues }
